module.exports = __webpack_public_path__ + "img/h52img.eb6d0f2f.png";